











































import { defineComponent } from "@vue/composition-api";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";

/**
 * 掲載依頼中バージョン 編集不可モーダル
 */
export default defineComponent({
  components: {
    OccModal,
    OccButton,
    OccHeading
  },
  name: "ReadonlyModal",
  emits: ["close", "unconfirm"],
  props: {
    headerMessage: {
      type: String,
      required: true
    },
    bodyMessage: {
      type: String,
      required: true
    },
    withdrawSubmissionButtonLabel: {
      type: String,
      required: true
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  }
});
